import { Subject } from 'rxjs';

export type LayoutThemeValue = 'classic-dark' | 'modern-dark' | 'modern-light';

export interface LayoutThemeOption {
  value: LayoutThemeValue;
  label: string;
  dotClass: string;
}

export const LAYOUT_THEME_STORAGE_KEY = 'st_layout_theme';
export const LAYOUT_THEME_CHANGE_EVENT = 'st-layout-theme-change';

const layoutThemeChangeSubject = new Subject<LayoutThemeValue>();
export const layoutThemeChanges$ = layoutThemeChangeSubject.asObservable();

const ALL_LAYOUT_THEMES: LayoutThemeOption[] = [
  { value: 'modern-dark', label: 'Modern Dark', dotClass: 'theme-dot--modern-dark' },
  { value: 'modern-light', label: 'Modern Light', dotClass: 'theme-dot--modern-light' },
  { value: 'classic-dark', label: 'Classic Dark', dotClass: 'theme-dot--classic-dark' },
];

export const LAYOUT_THEMES: LayoutThemeOption[] = ALL_LAYOUT_THEMES;

const LEGACY_LAYOUT_THEMES = ['classic-light'];

export function normalizeLayoutTheme(theme: string): LayoutThemeValue {
  if (theme === 'classic-light') {
    return 'modern-light';
  }

  const selected = LAYOUT_THEMES.find((option: LayoutThemeOption) => option.value === theme);
  return selected ? selected.value : 'modern-dark';
}

export function isModernLayoutTheme(theme: string): boolean {
  return theme === 'modern-dark' || theme === 'modern-light';
}

export function canUseLayoutTheme(_user: any, _environmentName: string): boolean {
  return true;
}

export function applyLayoutTheme(theme: LayoutThemeValue): void {
  theme = normalizeLayoutTheme(theme);
  const body = document.getElementById('main-body') || document.body;

  ALL_LAYOUT_THEMES.forEach((option: LayoutThemeOption) => {
    body.classList.remove('layout-' + option.value);
  });
  LEGACY_LAYOUT_THEMES.forEach((legacyTheme: string) => {
    body.classList.remove('layout-' + legacyTheme);
  });

  body.classList.add('layout-' + theme);
  body.setAttribute('data-layout-theme', theme);
  body.setAttribute('data-theme', theme === 'modern-light' ? 'light' : (theme === 'modern-dark' ? 'dark' : 'classic'));
  layoutThemeChangeSubject.next(theme);
  window.dispatchEvent(new Event(LAYOUT_THEME_CHANGE_EVENT));
}
